import { render } from "./acceptSMS.vue?vue&type=template&id=f273765c"
import script from "./acceptSMS.vue?vue&type=script&lang=js"
export * from "./acceptSMS.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__